import { Skeleton } from "primereact/skeleton";
import { PathCard } from "sj-ui-toolkit/src/atlas/components/ContentCard/PathCard/PathCard";
import {
  PATH_CARD_SMALL_HEIGHT,
  PATH_CARD_SMALL_WIDTH,
} from "sj-ui-toolkit/src/atlas/components/ContentCard/PathCard/PathCard.constants";

// Legacy bucket row: original horizontal-scroll layout used before the
// `upgraded-path-quests-row-ux` flag. Renders every card in a single
// overflow-x row, no "Show all" button, no completion indicator.
const LOADING_SKELETON_KEYS = Array.from({ length: 4 }, (_, i) => `skelly-${i}`);

export const BucketOfLearninRowOld = ({
  loading,
  name,
  description,
  id,
  learnins,
  variant,
  pathType,
}) => {
  if (learnins?.error) {
    return null;
  }

  const isQuest = pathType === "Quest";
  const isLoading = loading && learnins === undefined;

  // Hide rows with no available paths once we know they're settled empty.
  if (!isLoading && learnins?.length === 0) {
    return null;
  }

  return (
    <div className="mb-6">
      <h2 className={"atlas-h5 pb-2"}>{name}</h2>
      {description && <p>{description}</p>}
      <div className="overflow-x-auto flex gap-6 py-6">
        {isLoading
          ? LOADING_SKELETON_KEYS.map(skel => (
              <Skeleton
                key={`${id}-${skel}`}
                width={`${PATH_CARD_SMALL_WIDTH}px`}
                height={`${PATH_CARD_SMALL_HEIGHT}px`}
                className="mr-6"
              />
            ))
          : learnins?.map(learnin => (
              <PathCard
                key={learnin.id}
                cardSize="small"
                variant={variant}
                id={isQuest ? learnin.role?.id : learnin.id}
                name={learnin.name}
                description={learnin.description}
                pathType={pathType}
                status={learnin.status}
              />
            ))}
      </div>
    </div>
  );
};
